import { z } from 'zod';
import { Option } from '../../types/Option';

export type PowerFlowDirection = 'bidirectional' | 'input' | 'output';

const options = [
    { value: 'bidirectional', label: 'Bidirectional' },
    { value: 'input', label: 'Input' },
    { value: 'output', label: 'Output' },
] as Option<PowerFlowDirection>[];

const validator = z.enum(['bidirectional', 'input', 'output']).nullable().default(null);

export const PowerFlowDirection = {
    validator,
    literals: {
        bidirectional: z.literal<PowerFlowDirection>('bidirectional').default('bidirectional'),
        input: z.literal<PowerFlowDirection>('input').default('input'),
        output: z.literal<PowerFlowDirection>('output').default('output'),
    },
    options,
};
